import { Avatar, Box, Button, Chip, Grid, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import ConfirmationBox from 'src/Component/ConfirmationBox'
import SimpleModal from 'src/Component/SimpleModal'
import { useGetBranchGymByIdQuery } from 'src/api/branchGymApi'
import { AppDispatch } from 'src/store'
import { startPageLoader, stopPageLoader } from 'src/store/features/common/commonSlice'

type ViewBranchGymDetailsModalProps = {
  id: number
  open: boolean
  onClose: () => void
}
const ViewBranchGymDetailsModal = ({ id, open, onClose }: ViewBranchGymDetailsModalProps) => {
  const dispatch = useDispatch<AppDispatch>()
  const { data, isFetching, refetch } = useGetBranchGymByIdQuery(id)

  useEffect(() => {
    if (isFetching) {
      dispatch(startPageLoader())
    } else {
      dispatch(stopPageLoader())
    }
  }, [isFetching])

  return (
    <Box>
      <SimpleModal open={!!(open && id)} onClose={onClose}>
        {!!data && (
          <Box>
            {!!data?.picture && (
              <Box textAlign='center'>
                <img
                  src={data?.picture}
                  style={{
                    width: '100%',
                    height: '250px',
                    objectFit: 'cover',
                  }}
                />
              </Box>
            )}

            <Grid container mt={3}>
              <Grid xs={3}>
                <Typography variant='h4'>Gym Name:</Typography>
              </Grid>
              <Grid xs={9}>
                <Typography variant='h5'> {data?.name} </Typography>
              </Grid>
            </Grid>
            <Grid container mt={3}>
              <Grid xs={3}>
                <Typography variant='h4'>About:</Typography>
              </Grid>
              <Grid xs={9}>
                <Typography variant='h5'> {data?.about} </Typography>
              </Grid>
            </Grid>
            <Grid container mt={3}>
              <Grid xs={3}>
                <Typography variant='h4'>Address:</Typography>
              </Grid>
              <Grid xs={9}>
                <Typography variant='h5'>{data.address}</Typography>
              </Grid>
            </Grid>
            <Grid container mt={3}>
              <Grid xs={3}>
                <Typography variant='h4'>Rating :</Typography>
              </Grid>
              <Grid xs={9}>
                <Typography variant='h5'> {data.rating} </Typography>
              </Grid>
            </Grid>
            <Grid container mt={3}>
              <Grid xs={3}>
                <Typography variant='h4'>Open At:</Typography>
              </Grid>
              <Grid xs={9}>
                <Typography variant='h5'> {data.opened_at} </Typography>
              </Grid>
            </Grid>
            <Grid container mt={3}>
              <Grid xs={3}>
                <Typography variant='h4'>Close At:</Typography>
              </Grid>
              <Grid xs={9}>
                <Typography variant='h5'> {data.closed_at} </Typography>
              </Grid>
            </Grid>
            <Grid container mt={3}>
              <Grid xs={3}>
                <Typography variant='h4'>Latitude:</Typography>
              </Grid>
              <Grid xs={9}>
                <Typography variant='h5'>{data.latitude}</Typography>
              </Grid>
            </Grid>

            <Grid container mt={3}>
              <Grid xs={3}>
                <Typography variant='h4'>Longitude:</Typography>
              </Grid>
              <Grid xs={9}>
                <Typography variant='h5'> {data.longitude} </Typography>
              </Grid>
            </Grid>
          </Box>
        )}
      </SimpleModal>
    </Box>
  )
}

export default ViewBranchGymDetailsModal
